import { render, staticRenderFns } from "./listaFormaPagamento.vue?vue&type=template&id=3956e2f2&scoped=true&"
import script from "./listaFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./listaFormaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./listaFormaPagamento.vue?vue&type=style&index=0&id=3956e2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956e2f2",
  null
  
)

export default component.exports